import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-62be0cee"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-bar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: "logo"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "QianBot")
], -1))
const _hoisted_2 = ["src"]

import { useRoute, useRouter } from "vue-router";
import routes from "@/router/router";
import { computed } from "vue";
import { useLoginUserStore } from "@/store/userStore";
import checkAccess from "@/access/checkAccess";
import { userLogoutUsingGet } from "@/api/userController";
import message from "@arco-design/web-vue/es/message";
import ACCESS_ENUM from "@/access/accessEnum";


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const selectedKeys = computed(() => [route.path]);
const loginUserStore = useLoginUserStore();

const doMenuClick = (key: string) => {
  router.push({
    path: key,
  });
};

const visibleRoutes = computed(() => {
  return routes
    .filter((item) => item?.meta?.showInMenu)
    .filter((item) =>
      checkAccess(loginUserStore.loginUser, item.meta?.access as string)
    )
    .sort((a, b) => (a?.meta?.index as number) - (b?.meta?.index as number));
});

const handleSelect = (value: string) => {
  router.push({
    path: value,
  });
};
// 退出登录
const handleLogout = async () => {
  const res = await userLogoutUsingGet();
  if (res.data.code === 200) {
    loginUserStore.removerLoginUser();
    message.success("退出登录成功");
  } else {
    message.error("退出登录失败，" + res.data.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_doption = _resolveComponent("a-doption")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    id: "globalHeader",
    align: "center",
    wrap: false,
    justify: "space-between"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            mode: "horizontal",
            "selected-keys": selectedKeys.value,
            onMenuItemClick: doMenuClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, {
                key: "0",
                style: { padding: 0, marginRight: '38px' },
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRoutes.value, (item) => {
                return (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: item.path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["selected-keys"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { span: 3 }, {
        default: _withCtx(() => [
          (!_unref(loginUserStore).loginUser.id)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                href: "/user/login"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("登录")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_a_dropdown, {
                key: 1,
                position: "bl",
                onSelect: handleSelect as any
              }, {
                content: _withCtx(() => [
                  (_unref(loginUserStore).loginUser.userRole === _unref(ACCESS_ENUM).ADMIN)
                    ? (_openBlock(), _createBlock(_component_a_doption, {
                        key: 0,
                        value: "/admin"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("管理页面")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_doption, { value: "/user/center" }, {
                    default: _withCtx(() => [
                      _createTextVNode("个人中心")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_doption, { value: "/app/history" }, {
                    default: _withCtx(() => [
                      _createTextVNode("答题历史")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_doption, { value: "/chart/history" }, {
                    default: _withCtx(() => [
                      _createTextVNode("图表历史")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_doption, { value: "/app/my" }, {
                    default: _withCtx(() => [
                      _createTextVNode("我的应用")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_doption, {
                    value: "/",
                    onClick: handleLogout
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("退出登录")
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      (_unref(loginUserStore).loginUser.userAvatar)
                        ? (_openBlock(), _createBlock(_component_a_avatar, {
                            key: 0,
                            size: 50,
                            class: "avatar"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                alt: "avatar",
                                src: _unref(loginUserStore).loginUser.userAvatar
                              }, null, 8, _hoisted_2)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, _toDisplayString(_unref(loginUserStore).loginUser.userName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onSelect"]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})